// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Albert+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.-bottom-2 {
  bottom: -0.5rem;
}
.-right-3 {
  right: -0.75rem;
}
.-top-3 {
  top: -0.75rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-10 {
  bottom: 2.5rem;
}
.bottom-24 {
  bottom: 6rem;
}
.end-0 {
  inset-inline-end: 0px;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-10 {
  left: 2.5rem;
}
.left-14 {
  left: 3.5rem;
}
.left-5 {
  left: 1.25rem;
}
.left-7 {
  left: 1.75rem;
}
.right-0 {
  right: 0px;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.\\!z-0 {
  z-index: 0 !important;
}
.\\!z-50 {
  z-index: 50 !important;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[1001\\] {
  z-index: 1001;
}
.col-auto {
  grid-column: auto;
}
.m-0 {
  margin: 0px;
}
.m-1 {
  margin: 0.25rem;
}
.m-2 {
  margin: 0.5rem;
}
.m-3 {
  margin: 0.75rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.-mb-8 {
  margin-bottom: -2rem;
}
.-mb-px {
  margin-bottom: -1px;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.me-1 {
  margin-inline-end: 0.25rem;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.me-3 {
  margin-inline-end: 0.75rem;
}
.me-auto {
  margin-inline-end: auto;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-auto {
  margin-right: auto;
}
.ms-1 {
  margin-inline-start: 0.25rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.ms-4 {
  margin-inline-start: 1rem;
}
.ms-auto {
  margin-inline-start: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[19px\\] {
  margin-top: 19px;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-0 {
  height: 0px;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-80 {
  height: 20rem;
}
.h-\\[13rem\\] {
  height: 13rem;
}
.h-\\[15rem\\] {
  height: 15rem;
}
.h-\\[19rem\\] {
  height: 19rem;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-\\[calc\\(100vh-64px\\)\\] {
  max-height: calc(100vh - 64px);
}
.min-h-\\[45px\\] {
  min-height: 45px;
}
.\\!w-\\[40\\%\\] {
  width: 40% !important;
}
.\\!w-\\[52\\%\\] {
  width: 52% !important;
}
.w-0 {
  width: 0px;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-8 {
  width: 2rem;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[10rem\\] {
  min-width: 10rem;
}
.min-w-\\[16rem\\] {
  min-width: 16rem;
}
.min-w-full {
  min-width: 100%;
}
.max-w-\\[240px\\] {
  max-width: 240px;
}
.max-w-full {
  max-width: 100%;
}
.max-w-max {
  max-width: max-content;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.border-collapse {
  border-collapse: collapse;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.resize-none {
  resize: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.\\!items-center {
  align-items: center !important;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.\\!justify-center {
  justify-content: center !important;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-x-10 {
  column-gap: 2.5rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.justify-self-center {
  justify-self: center;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.text-wrap {
  text-wrap: wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[100\\%\\] {
  border-radius: 100%;
}
.rounded-\\[3px\\] {
  border-radius: 3px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-se-md {
  border-start-end-radius: 0.375rem;
}
.rounded-ss-md {
  border-start-start-radius: 0.375rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.\\!border-b {
  border-bottom-width: 1px !important;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l-\\[10px\\] {
  border-left-width: 10px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-\\[10px\\] {
  border-right-width: 10px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-\\[10px\\] {
  border-top-width: 10px;
}
.border-dashed {
  border-style: dashed;
}
.\\!border-slate-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#0d4473\\] {
  --tw-border-opacity: 1;
  border-color: rgb(13 68 115 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1e4466\\] {
  --tw-border-opacity: 1;
  border-color: rgb(30 68 102 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F37920\\] {
  --tw-border-opacity: 1;
  border-color: rgb(243 121 32 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-r-transparent {
  border-right-color: transparent;
}
.border-t-\\[\\#0d4473\\] {
  --tw-border-opacity: 1;
  border-top-color: rgb(13 68 115 / var(--tw-border-opacity, 1));
}
.border-t-\\[\\#F37920\\] {
  --tw-border-opacity: 1;
  border-top-color: rgb(243 121 32 / var(--tw-border-opacity, 1));
}
.\\!bg-\\[\\#F37920\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 121 32 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[rgb\\(0\\2c 97\\2c 254\\)\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 97 254 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-green-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-red-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#0d4473\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(13 68 115 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f4372\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 67 114 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e4466\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 68 102 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#333333\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(51 51 51 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F37920\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 121 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eff2f3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 242 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8f9fa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafafa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\] {
  background-color: ;
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-px {
  padding: 1px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pe-1 {
  padding-inline-end: 0.25rem;
}
.pe-2 {
  padding-inline-end: 0.5rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.ps-3 {
  padding-inline-start: 0.75rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.text-left {
  text-align: left;
}
.\\!text-center {
  text-align: center !important;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-top {
  vertical-align: top;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.\\!text-2xl {
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.\\!text-\\[12px\\] {
  font-size: 12px !important;
}
.\\!text-\\[20px\\] {
  font-size: 20px !important;
}
.\\!text-\\[24px\\] {
  font-size: 24px !important;
}
.\\!text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.\\!text-sm {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.\\!text-xl {
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\!font-semibold {
  font-weight: 600 !important;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-7 {
  line-height: 1.75rem;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.\\!text-\\[\\#0f172a\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-gray-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-green-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-red-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#0f4372\\] {
  --tw-text-opacity: 1;
  color: rgb(15 67 114 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1e4466\\] {
  --tw-text-opacity: 1;
  color: rgb(30 68 102 / var(--tw-text-opacity, 1));
}
.text-\\[\\#212529\\] {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F37920\\] {
  --tw-text-opacity: 1;
  color: rgb(243 121 32 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.\\!no-underline {
  text-decoration-line: none !important;
}
.opacity-50 {
  opacity: 0.5;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
/* Hide close icon inside RangePicker */
.hide-clear-icon .ant-picker-clear {
    display: none !important;
  }

html {
  position: relative;
  min-height: 100%;
}

body,
h1,
h2,
h3,
h4,
h5,
h6 {
  /* font-family: var(--font-primary); */
  font-family: Roboto, sans-serif !important;

}

a {
  text-decoration: none !important;
}

.btn-primary,
.page-item.active .page-link,
.v-avatar {
  background-color: #F37920 !important
}

.tooltip-white>.tooltip-inner,
.tooltip-white>.tooltip-arrow {
  background-color: #fff;
  --bs-tooltip-bg: #fff;
}

.btn-outline-primary {
  --bs-btn-color: #F37920 !important;
  --bs-btn-border-color: #F37920 !important;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #F37920 !important;
  --bs-btn-hover-border-color: #F37920 !important;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #F37920 !important;
  --bs-btn-active-border-color: #F37920 !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #F37920 !important;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F37920 !important;
  --bs-gradient: none;
}


.list-group-item {
  background-color: #F37920 !important;
  color: #fff !important;
  border-right-color: #fff !important;
}

.download-overlay .tooltip-arrow,
.download-overlay .tooltip-inner {
  background-color: #fff !important;
}

.v-icons,
.nav-search {
  cursor: pointer;
}

.v-table {
  max-height: 80vh;
  overflow-y: scroll;
}

.pv-blackdrop>.block-ui-container {
  background-color: #645f5f;
  opacity: 0.9;
}

.pv-blackdrop .block-ui-message-container .block-ui-message {
  color: #fff;
  font-size: 30px;
}

.nav-search {
  font-size: 22px;
  padding: 10px;
}

.table-container {
  margin-top: 20px;
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

th {
  background-color: #f0f0f0;
}

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border: 1px solid #ccc;
  padding: 20px;
  z-index: 1000;
}

.modal-content {
  display: flex;
  flex-direction: column;
}

textarea {
  width: 100%;
  height: 100px;
  margin-bottom: 10px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
}

.modal-actions button {
  margin-left: 10px;
  padding: 5px 10px;
}

.modal-open .modal {
  background: transparent;
}


/* CUSTOM */

:where(.css-dev-only-do-not-override-11lehqq).ant-collapse>.ant-collapse-item {
  border-bottom: none;
  background: #fafafa;
  border-bottom: 1px solid #f1f1f1;
}

:where(.css-dev-only-do-not-override-11lehqq).ant-collapse .ant-collapse-content>.ant-collapse-content-box {
  padding: 5px;
}

:where(.css-dev-only-do-not-override-11lehqq).ant-collapse .ant-collapse-content {
  color: rgba(0, 0, 0, 0.88);
  background-color: #ffffff;
  margin: 15px;
  border-top: none;
}

:where(.css-dev-only-do-not-override-11lehqq).ant-collapse {
  border: none
}

.modal-backdrop.show {
  z-index: 99;
}

.sheet-summary-list-group .list-group-item {
  color: #212529 !important;
  background-color: #fff !important;
}

.iq-sidebar {
  z-index: 999 !important;
}

.excel-sheet-modal .modal-dialog {
  min-width: 80%;
}

.modal .modal-content form.login-content {
  height: auto;
}

.profile-header .btn-link {
  text-decoration: none;
}

.profile-header .btn-link:hover {
  color: #145886 !important;
}

#user-list-table .btn-link:hover {
  color: inherit !important;
}

.login-content .floating-label .checkbox-group label {
  position: relative;
  top: 8px;
}

.collapse {
  visibility: visible;
}

#page-topbar .search-box input {
  height: 38px;
  font-size: 0.9rem;
}

/*Progressbar*/
.steps-progressbar .circle {
  width: 40px;
  height: 40px;
  border: 2px solid #F37920;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  position: relative;
}

.steps-progressbar .step-number {
  font-size: 1rem;
  color: #F37920;
}

.steps-progressbar .step-label {
  margin-top: 8px;
  font-size: 1rem;
  color: #F37920;
}

.steps-progressbar .line {
  width: 100%;
  height: 2px;
  margin-top: 20px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 20px;
  z-index: -1;
}

.steps-progressbar .bg-primary {
  background-color: #F37920 !important;
}

.steps-progressbar .bg-light {
  background-color: #e9ecef !important;
}

.steps-progressbar .progress-line {
  height: 2px;
  top: 20px;
  /* Aligns the line with the circle vertically */
  z-index: 1;
  position: absolute;
}

/*Progressbar*/


/* Dashboard New styles start */
:root {
  --primary-background: #F37920 !important;
  --primary-loader: #032d46 !important;
  /* Buttons*/
  --bs-btn-color: #F37920 !important;
  --bs-btn-border-color: #F37920 !important;
  --bs-btn-hover-border-color: #F37920 !important;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-border-color: #F37920 !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #F37920 !important;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F37920 !important;
  --bs-gradient: none;

  /* font*/
  --font-primary: 'Albert Sans', sans-serif;
  --text-primary: #000;
  --custom-background-color-white: #FFFFFF;
  --font-size-xs: 0.75rem;
  /* 12px */
  --font-size-sm: 0.875rem;
  /* 14px */
  --font-size-md: 1rem;
  /* 16px */
  --font-size-lg: 1.125rem;
  /* 18px */
  --font-size-xl: 1.25rem;
  /* 20px */
  --font-size-xxl: 1.5rem;
  /* 24px */
  --font-size-xxxl: 1.875rem;
  /* 30px */
  --font-size-xxxxl: 2.375rem;
  /* 38px */

  /* Font Weights */
  --font-weight-light: 300;
  --font-weight-regular: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --font-weight-extrabold: 800;

}

[data-theme="dark"] {
  --font-primary: 'Albert Sans', sans-serif;
  --primary-color: #F37920;
  --text-primary: #fff;
  --custom-background-color-white: #2F3035;

}

/* Dashboard Container */
.dashboard-container {
  background-color: #f8f9fa;
  min-height: calc(100vh - 200px);
  padding: 1.5rem;
}

/* Welcome Section */
.dashboard-welcome-section {
  margin-bottom: 1.5rem;
}

.dashboard-welcome-text {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 0;
}

.dashboard-user-badge {
  background-color: #F37920;
  color: var(--custom-background-color-white);
  border-radius: 0.375rem;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-large);
}

/* Dashboard Cards Row */
.dashboard-cards-row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 1.5rem;
}

.dashboard-card-col {
  margin-bottom: 1.5rem;
  flex: 0 0 auto;
}

/* Dashboard Card */
.dashboard-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  background: var(--custom-background-color-white);
  cursor: pointer;
}

.dashboard-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.dashboard-card-body {
  padding: 1.5rem;
}

/* Card Header */
.dashboard-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.dashboard-card-title-wrapper {
  display: flex;
  align-items: center;
}

.dashboard-icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  transition: all 0.3s ease;
  font-size: var(--font-size-xxl);

}

.dashboard-card:hover .dashboard-icon-wrapper {
  transform: scale(1.1);
}

.dashboard-card-title {
  margin-bottom: 0;
  font-weight: 600;
  color: #2c3e50;
  font-size: var(--font-size-md);
}

/* Stats Section */
.dashboard-stats-section {
  width: 100%;
}

.dashboard-stat-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.dashboard-stat-left {
  display: flex;
  align-items: center;
}

.dashboard-stat-number {
  font-weight: bold;
  margin-right: 0.5rem;
  font-size: var(--font-size-xxl);
  color: var(--text-primary);
}

.dashboard-pending-badge {
  background-color: rgba(241, 173, 180, 0.7);
  color: #e96565;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
}

.dashboard-stat-right {
  text-align: right;
}

.dashboard-stat-label {
  color: #6c757d;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
}

/* Add Button */
.dashboard-add-button {
  background-color: var(--primary-background);
  color: white;
  padding: 0.25rem 0.5rem;
  margin-left: 0.5rem;
  border-radius: 0.25rem;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  margin-top: 0.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dashboard-add-button:hover {
  background-color: var(--primary-background) !important;
  color: var(--custom-background-color-white);
}

.dashboard-add-icon {
  margin-right: 0.25rem;
}

/* Responsive Design */
@media (min-width: 1200px) {
  .dashboard-card-col {
    width: 33.333333%;
    max-width: 33.333333%;
  }
}

@media (min-width: 768px) and (max-width: 1199.98px) {
  .dashboard-card-col {
    width: 50%;
    max-width: 50%;
  }
}

@media (max-width: 767.98px) {
  .dashboard-card-col {
    width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .dashboard-card-body {
    padding: 1.5rem !important;
  }

  .dashboard-icon-wrapper {
    width: 40px !important;
    height: 40px !important;
    font-size: var(-font-size-xl) !important;
  }

  .dashboard-stat-number {
    font-size: var(-font-size-xl) !important;
  }

  .dashboard-welcome-text {
    font-size: var(-font-size-xl)
  }

  .dashboard-container {
    padding: 1rem;
  }
}

@media (max-width: 576px) {
  .dashboard-container {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .dashboard-stat-row {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .dashboard-stat-right {
    text-align: left !important;
    width: 100%;
    margin-top: 0.5rem;
  }

  .dashboard-card-title {
    font-size: var(-font-size-sm);
  }

  .dashboard-stat-number {
    font-size: 18px !important;
  }

  .dashboard-welcome-text {
    font-size: 1.1rem;
  }

  .dashboard-user-badge {
    font-size: var(-font-size-md);
    padding: 0.4rem 0.6rem;
  }
}

.muted-hr {
  border: none;
  border-top: 2px solid #c5c6c7;
  margin: 1rem 0;
}

.vertical-hr {
  border: none;
  border-left: 2px solid #c5c6c7;
  height: 50px;
}

/* Dashboard New styles end */
body[data-sidebar-size=sm] .vertical-menu #sidebar-menu ul li:hover ul li span {
  display: block;
}
#sidebar-menu ul li div.menu-parent-link {
  padding: .6rem 1rem;
  color: #585f64;
  position: relative;
  font-weight: 400;
  transition: all .4s;
  margin: 0 10px;
  /* border-radius: 3px; */
  
  font-size: 16px;
  font-family: Roboto, sans-serif;
  -webkit-box-align: center;
}

#sidebar-menu ul li div.menu-parent-link .nav-icon {
  width: 16px;
  height: 16px;
  display: inline-block;
  min-width: 1.5rem;
  vertical-align: middle;
  color: #585f64;
  transition: all .3s;
  top: -1px;
}

#sidebar-menu ul li div.menu-parent-link:hover,
#sidebar-menu ul li div.menu-parent-link:hover .nav-icon {
  color: #145886;
}

body[data-sidebar-size=sm] .vertical-menu #sidebar-menu>ul>li span,
body[data-sidebar-size=sm] .vertical-menu #sidebar-menu>ul>li li span,
body[data-sidebar-size=sm] .vertical-menu #sidebar-menu>ul>li .ms-auto {
  display: none;
  padding-left: 25px;
}

body[data-sidebar=dark][data-sidebar-size=sm] .vertical-menu #sidebar-menu ul li div.menu-parent-link:hover span {
  display: block;
}


body[data-sidebar-size=sm] .vertical-menu #sidebar-menu>ul>li:hover>div.menu-parent-link+ul {
  left: 25px;
  width: 241px;
}

body[data-sidebar-size=sm] .vertical-menu #sidebar-menu>ul>li:hover>div.menu-parent-link span {
  display: block;
}


body[data-sidebar=dark][data-sidebar-size=sm] .vertical-menu #sidebar-menu>ul>li:hover>div.menu-parent-link {
  background: #E6F2FF;
  color: var(--bs-btn-active-bg);
  position: relative;
  width: calc(210px + 70px);
  transition: none;
  /* box-shadow: inset 0 3px 10px 0 rgba(154, 161, 171, .2); */
}


.bulk-import-offcanvas {
  width: 400px;
}

@media (max-width: 768px) {
  .bulk-import-offcanvas {
    width: 100%;
  }
}

.custom-offcanvas-width {
  width: 400px;
}

@media (max-width: 768px) {
  .custom-offcanvas-width {
    width: 100%;
  }
}

.role-selection-offcanvas {
  height: 246px !important;
}

@media (max-width: 768px) {
  .role-selection-offcanvas {
    height: 250px;
  }
}

.responsive-search-input {
  width: 100%;
}

/* Small screens (xs) - Hide search completely or make very small */
@media (max-width: 860px) {
  .search-box.pf-search-box {
    display: none !important;
    /* Completely hide on mobile if needed */
  }

  /* OR if you want to keep it but make it smaller: */
  /*
    .responsive-search-input {
      width: 120px !important;
      font-size: 12px;
    }
    .search-box.pf-search-box form {
      padding: 0.25rem !important;
    }
    */
}

/* Medium screens (sm to md) - Reduce search width, hide time */
@media (min-width: 576px) and (max-width: 991.98px) {
  .responsive-search-input {
    max-width: 250px;
  }
}

/* Large screens and up - Full width search, show time */
@media (min-width: 992px) {
  .responsive-search-input {
    max-width: none;
  }
}


/* new css */


.dashboard-user-badge {
  background-color: #F37920;
  color: var(--custom-background-color-white);
  /* padding: 0.5rem 1.75rem 6px 29px; */
  padding: 7px 35px 7px 35px;
}

.btn-primary,
.page-item.active .page-link,
.v-avatar {
  background-color: #F37920 !important;
  border-color: #F37920;
}


button.btn.btn-primary.mt-3.btn.btn-primary {
  padding: 6px 25px 6px 25px;
}

button.btn-siz.btn.btn-primary {
  padding: 8px 30px 8px 30px;
}

button.btn.btn-primary {
  font-size: 14px;
}

a.pf-btn.btn-primary.pf-nav-btn {
  padding: 8px 29px 10px 29px;
  margin-left: 0.5rem;
  border-radius: 0.375rem;
}

button.py-0.px-1.\\!text-\\[12px\\].btn.btn-primary.btn-sm {
  padding: 8px 25px 8px 25px !important;
}

button.py-0.px-1.\\!text-\\[12px\\].btn.btn-outline-primary.btn-sm {
  padding: 8px 25px 8px 25px !important;
}

.bg-\\[\\#0d4473\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 97 254);
}


button.me-2.btn.btn-success {
  padding: 5px 26px 5px 26px;
}

#page-topbar .search-box input {
  height: 38px;
  font-size: 15px;
}


.dashboard-stat-number {
  font-size: 20px;
}

@media (min-width: 768px) {
  h6.m-2 {
    font-weight: 500;
  }
}


@media (min-width: 1024px) {
  h6.m-2 {
    font-weight: 600;
  }
}

.d-flex.flex-column.offcanvas-body {
  overflow: hidden;
}

.border-t-\\[\\#0d4473\\] {
  --tw-border-opacity: 1;
  border-top-color: rgb(0 97 254);
}

table.core-ui-table thead tr,
table.core-ui-table tbody tr:hover,
table.core-ui-table tbody tr:hover td {
    background-color: #f9fafb;
}

table.core-ui-table thead tr th {
  background-color: inherit;
}
table.core-ui-table tr{
  border: 1px solid #ddd;
  border-bottom-width: 1px;
}

table.core-ui-table tr td,
table.core-ui-table tr th {
  border: none;
}

.hd-card {
  padding: 0px !important;
  padding-bottom: 12px !important;
}

/* .btn-outline-secondary:hover {
    color: var(--bs-btn-hover-color);
    background-color: #F37920!important;
    border-color: #F37920!important;
} */
.bg-green-500 {
  --tw-bg-opacity: 1;
  /* background-color: rgb(241 230 109); */
  background-color: rgb(0 97 254);
}

/* .form-select {
    padding: 13.375px 2.25rem .375rem .75rem!important;
} */

.fw-semibold {
  color: #01041b;
}

.bg-gradient.p-3.card-header {
  padding: 12px 15px 12px 15px !important;
}


.no-vertical-border tr {
  border-left: none !important;
  border-right: none !important;
}
.no-vertical-border td {
  border-left: none !important;
  border-right: none !important;
}
.no-vertical-border th {
  border-left: none !important;
  border-right: none !important;
}

/* Custom styles for your tabs */
.custom-tabs .nav-link {
  color: rgb(0 97 254); /* Default gray color */
  transition: color 0.2s ease;
}

.custom-tabs .nav-link:hover {
  color: #000000 !important; /* Black on hover */
}

.custom-tabs .nav-link.active {
  color: #F37920 !important; /* Blue for active tab */
  border-bottom-color: #F37920 !important;
}

.custom-tabs .nav-link.active:hover {
  color: #000000 !important; /* Blue for active tab */
  border-bottom-color: #000000 !important;
}

.border.border-blue {
  border-color:  rgb(0 97 254) !important;
}

.react-datepicker__month-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  padding: 1rem;
}

.react-datepicker__month-text {
  padding: 0.5rem 0;
  text-align: center;
  font-weight: 500;
  border-radius: 0.375rem;
  cursor: pointer;
}

.react-datepicker__month-text:hover {
  background-color: #e2e8f0;
}

.react-datepicker__month-text--selected {
  background-color: #2563eb; 
  color: white;
}
.custom-yellow-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background-color: #FEF3C7; 
  color: #92400E;            
  font-size: 16px;
  font-weight: 500;
  border-radius: 9999px;     
}

.tooltip.show {
    opacity: 1!important;
}
:where(.css-dev-only-do-not-override-mc1tut).ant-picker:hover .ant-picker-suffix:not(:last-child) {
    opacity: 1;
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-blue-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#0a3458\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(10 52 88 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#0a3a5e\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(10 58 94 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#333333\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(51 51 51 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f1f1f1\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 241 241 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-opacity-100:hover {
  --tw-bg-opacity: 1;
}
.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-800:hover {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:shadow-\\[0_0_15px_5px_var\\(--colr-pri\\)\\]:hover {
  --tw-shadow: 0 0 15px 5px var(--colr-pri);
  --tw-shadow-colored: 0 0 15px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:\\[background-color\\:\\#F37920\\]:hover {
  background-color: #F37920;
}
.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.focus\\:border-transparent:focus {
  border-color: transparent;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#0d4473\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(13 68 115 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.active\\:bg-\\[\\#083048\\]:active {
  --tw-bg-opacity: 1;
  background-color: rgb(8 48 72 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
@media (min-width: 640px) {

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:max-h-\\[800px\\] {
    max-height: 800px;
  }

  .sm\\:w-1\\/4 {
    width: 25%;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-2\\/4 {
    width: 50%;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:gap-0 {
    gap: 0px;
  }

  .sm\\:self-center {
    align-self: center;
  }

  .sm\\:p-16 {
    padding: 4rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:text-right {
    text-align: right;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 768px) {

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 1024px) {

  .lg\\:max-h-\\[700px\\] {
    max-height: 700px;
  }

  .lg\\:w-1\\/4 {
    width: 25%;
  }

  .lg\\:w-3\\/4 {
    width: 75%;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:p-32 {
    padding: 8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AA05BjB,uCAAuC;AACvC;IACE,wBAAwB;EAC1B;;AA15BF;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,sCAAsC;EACtC,0CAA0C;;AAE5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE;AACF;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,+CAA+C;EAC/C,uCAAuC;EACvC,2BAA2B;EAC3B,sCAAsC;EACtC,gDAAgD;EAChD,4DAA4D;EAC5D,2CAA2C;EAC3C,iCAAiC;EACjC,kDAAkD;EAClD,mBAAmB;AACrB;;;AAGA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;;AAGA,WAAW;;AAEX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,SAAS;EACT,+CAA+C;EAC/C,UAAU;EACV,kBAAkB;AACpB;;AAEA,cAAc;;;AAGd,+BAA+B;AAC/B;EACE,wCAAwC;EACxC,oCAAoC;EACpC,WAAW;EACX,kCAAkC;EAClC,yCAAyC;EACzC,+CAA+C;EAC/C,uCAAuC;EACvC,gDAAgD;EAChD,4DAA4D;EAC5D,2CAA2C;EAC3C,iCAAiC;EACjC,kDAAkD;EAClD,mBAAmB;;EAEnB,QAAQ;EACR,yCAAyC;EACzC,oBAAoB;EACpB,wCAAwC;EACxC,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,SAAS;EACT,oBAAoB;EACpB,SAAS;EACT,wBAAwB;EACxB,SAAS;EACT,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,SAAS;EACT,2BAA2B;EAC3B,SAAS;;EAET,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;;AAE9B;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,oBAAoB;EACpB,wCAAwC;;AAE1C;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,uBAAuB;EACvB,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;;AAEjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE,2CAA2C;EAC3C,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EAEnB,sBAAsB;EACtB,8BAA8B;EAC9B,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;EACtD,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;IACV,cAAc;EAChB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE;EACF;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;EACxB;AACF;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,wBAAwB;;EAExB,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EAEd,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,4DAA4D;AAC9D;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;AACb;;AAEA,mEAAmE;AACnE;EACE;IACE,wBAAwB;IACxB,wCAAwC;EAC1C;;EAEA,mDAAmD;EACnD;;;;;;;;KAQG;AACL;;AAEA,+DAA+D;AAC/D;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,eAAe;EACjB;AACF;;;AAGA,YAAY;;;AAGZ;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;;;EAGE,oCAAoC;EACpC,qBAAqB;AACvB;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;;GAIG;AACH;EACE,kBAAkB;EAClB,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;;GAEG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;;AAGA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,oBAAoB,EAAE,uBAAuB;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;AAChD;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,uCAAuC;AACzC;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;IACI,oBAAoB;AACxB;AAOA;IACI,UAAU;AACd;AAn6BA;EAAA;AAo6BA;AAp6BA;EAAA,kBAo6BA;EAp6BA,kBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,sBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,sBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,kBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,kBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,kBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,kBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,kBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,kBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,kBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,kBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA;AAo6BA;AAp6BA;EAAA,oBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,oBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,oBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,oBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,oBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA;AAo6BA;AAp6BA;EAAA,yCAo6BA;EAp6BA,wDAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA;AAo6BA;AAp6BA;EAAA,sBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA;AAo6BA;AAp6BA;EAAA,8BAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,2GAo6BA;EAp6BA,yGAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,2GAo6BA;EAp6BA,yGAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,oBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,oBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,oBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,oBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA;AAo6BA;AAp6BA;EAAA,kBAo6BA;EAp6BA;AAo6BA;AAp6BA;EAAA,oBAo6BA;EAp6BA;AAo6BA;AAp6BA;;EAAA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA,oBAo6BA;IAp6BA;EAo6BA;;EAp6BA;IAAA,qBAo6BA;IAp6BA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA,eAo6BA;IAp6BA;EAo6BA;;EAp6BA;IAAA,mBAo6BA;IAp6BA;EAo6BA;;EAp6BA;IAAA,mBAo6BA;IAp6BA;EAo6BA;AAAA;AAp6BA;;EAAA;IAAA;EAo6BA;AAAA;AAp6BA;;EAAA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;;EAp6BA;IAAA;EAo6BA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import url('https://fonts.googleapis.com/css2?family=Albert+Sans:wght@400;500;600;700&display=swap');\n\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  /* font-family: var(--font-primary); */\n  font-family: Roboto, sans-serif !important;\n\n}\n\na {\n  text-decoration: none !important;\n}\n\n.btn-primary,\n.page-item.active .page-link,\n.v-avatar {\n  background-color: #F37920 !important\n}\n\n.tooltip-white>.tooltip-inner,\n.tooltip-white>.tooltip-arrow {\n  background-color: #fff;\n  --bs-tooltip-bg: #fff;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #F37920 !important;\n  --bs-btn-border-color: #F37920 !important;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #F37920 !important;\n  --bs-btn-hover-border-color: #F37920 !important;\n  --bs-btn-focus-shadow-rgb: 13, 110, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #F37920 !important;\n  --bs-btn-active-border-color: #F37920 !important;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #F37920 !important;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #F37920 !important;\n  --bs-gradient: none;\n}\n\n\n.list-group-item {\n  background-color: #F37920 !important;\n  color: #fff !important;\n  border-right-color: #fff !important;\n}\n\n.download-overlay .tooltip-arrow,\n.download-overlay .tooltip-inner {\n  background-color: #fff !important;\n}\n\n.v-icons,\n.nav-search {\n  cursor: pointer;\n}\n\n.v-table {\n  max-height: 80vh;\n  overflow-y: scroll;\n}\n\n.pv-blackdrop>.block-ui-container {\n  background-color: #645f5f;\n  opacity: 0.9;\n}\n\n.pv-blackdrop .block-ui-message-container .block-ui-message {\n  color: #fff;\n  font-size: 30px;\n}\n\n.nav-search {\n  font-size: 22px;\n  padding: 10px;\n}\n\n.table-container {\n  margin-top: 20px;\n  overflow-x: auto;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth,\ntd {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n}\n\nth {\n  background-color: #f0f0f0;\n}\n\n.modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border: 1px solid #ccc;\n  padding: 20px;\n  z-index: 1000;\n}\n\n.modal-content {\n  display: flex;\n  flex-direction: column;\n}\n\ntextarea {\n  width: 100%;\n  height: 100px;\n  margin-bottom: 10px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.modal-actions button {\n  margin-left: 10px;\n  padding: 5px 10px;\n}\n\n.modal-open .modal {\n  background: transparent;\n}\n\n\n/* CUSTOM */\n\n:where(.css-dev-only-do-not-override-11lehqq).ant-collapse>.ant-collapse-item {\n  border-bottom: none;\n  background: #fafafa;\n  border-bottom: 1px solid #f1f1f1;\n}\n\n:where(.css-dev-only-do-not-override-11lehqq).ant-collapse .ant-collapse-content>.ant-collapse-content-box {\n  padding: 5px;\n}\n\n:where(.css-dev-only-do-not-override-11lehqq).ant-collapse .ant-collapse-content {\n  color: rgba(0, 0, 0, 0.88);\n  background-color: #ffffff;\n  margin: 15px;\n  border-top: none;\n}\n\n:where(.css-dev-only-do-not-override-11lehqq).ant-collapse {\n  border: none\n}\n\n.modal-backdrop.show {\n  z-index: 99;\n}\n\n.sheet-summary-list-group .list-group-item {\n  color: #212529 !important;\n  background-color: #fff !important;\n}\n\n.iq-sidebar {\n  z-index: 999 !important;\n}\n\n.excel-sheet-modal .modal-dialog {\n  min-width: 80%;\n}\n\n.modal .modal-content form.login-content {\n  height: auto;\n}\n\n.profile-header .btn-link {\n  text-decoration: none;\n}\n\n.profile-header .btn-link:hover {\n  color: #145886 !important;\n}\n\n#user-list-table .btn-link:hover {\n  color: inherit !important;\n}\n\n.login-content .floating-label .checkbox-group label {\n  position: relative;\n  top: 8px;\n}\n\n.collapse {\n  visibility: visible;\n}\n\n#page-topbar .search-box input {\n  height: 38px;\n  font-size: 0.9rem;\n}\n\n/*Progressbar*/\n.steps-progressbar .circle {\n  width: 40px;\n  height: 40px;\n  border: 2px solid #F37920;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.2rem;\n  position: relative;\n}\n\n.steps-progressbar .step-number {\n  font-size: 1rem;\n  color: #F37920;\n}\n\n.steps-progressbar .step-label {\n  margin-top: 8px;\n  font-size: 1rem;\n  color: #F37920;\n}\n\n.steps-progressbar .line {\n  width: 100%;\n  height: 2px;\n  margin-top: 20px;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 20px;\n  z-index: -1;\n}\n\n.steps-progressbar .bg-primary {\n  background-color: #F37920 !important;\n}\n\n.steps-progressbar .bg-light {\n  background-color: #e9ecef !important;\n}\n\n.steps-progressbar .progress-line {\n  height: 2px;\n  top: 20px;\n  /* Aligns the line with the circle vertically */\n  z-index: 1;\n  position: absolute;\n}\n\n/*Progressbar*/\n\n\n/* Dashboard New styles start */\n:root {\n  --primary-background: #F37920 !important;\n  --primary-loader: #032d46 !important;\n  /* Buttons*/\n  --bs-btn-color: #F37920 !important;\n  --bs-btn-border-color: #F37920 !important;\n  --bs-btn-hover-border-color: #F37920 !important;\n  --bs-btn-focus-shadow-rgb: 13, 110, 253;\n  --bs-btn-active-border-color: #F37920 !important;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #F37920 !important;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #F37920 !important;\n  --bs-gradient: none;\n\n  /* font*/\n  --font-primary: 'Albert Sans', sans-serif;\n  --text-primary: #000;\n  --custom-background-color-white: #FFFFFF;\n  --font-size-xs: 0.75rem;\n  /* 12px */\n  --font-size-sm: 0.875rem;\n  /* 14px */\n  --font-size-md: 1rem;\n  /* 16px */\n  --font-size-lg: 1.125rem;\n  /* 18px */\n  --font-size-xl: 1.25rem;\n  /* 20px */\n  --font-size-xxl: 1.5rem;\n  /* 24px */\n  --font-size-xxxl: 1.875rem;\n  /* 30px */\n  --font-size-xxxxl: 2.375rem;\n  /* 38px */\n\n  /* Font Weights */\n  --font-weight-light: 300;\n  --font-weight-regular: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  --font-weight-extrabold: 800;\n\n}\n\n[data-theme=\"dark\"] {\n  --font-primary: 'Albert Sans', sans-serif;\n  --primary-color: #F37920;\n  --text-primary: #fff;\n  --custom-background-color-white: #2F3035;\n\n}\n\n/* Dashboard Container */\n.dashboard-container {\n  background-color: #f8f9fa;\n  min-height: calc(100vh - 200px);\n  padding: 1.5rem;\n}\n\n/* Welcome Section */\n.dashboard-welcome-section {\n  margin-bottom: 1.5rem;\n}\n\n.dashboard-welcome-text {\n  color: #2c3e50;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.dashboard-user-badge {\n  background-color: #F37920;\n  color: var(--custom-background-color-white);\n  border-radius: 0.375rem;\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-large);\n}\n\n/* Dashboard Cards Row */\n.dashboard-cards-row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 1.5rem;\n}\n\n.dashboard-card-col {\n  margin-bottom: 1.5rem;\n  flex: 0 0 auto;\n}\n\n/* Dashboard Card */\n.dashboard-card {\n  transition: all 0.3s ease;\n  border-radius: 12px;\n  background: var(--custom-background-color-white);\n  cursor: pointer;\n}\n\n.dashboard-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;\n}\n\n.dashboard-card-body {\n  padding: 1.5rem;\n}\n\n/* Card Header */\n.dashboard-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.dashboard-card-title-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.dashboard-icon-wrapper {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 1rem;\n  transition: all 0.3s ease;\n  font-size: var(--font-size-xxl);\n\n}\n\n.dashboard-card:hover .dashboard-icon-wrapper {\n  transform: scale(1.1);\n}\n\n.dashboard-card-title {\n  margin-bottom: 0;\n  font-weight: 600;\n  color: #2c3e50;\n  font-size: var(--font-size-md);\n}\n\n/* Stats Section */\n.dashboard-stats-section {\n  width: 100%;\n}\n\n.dashboard-stat-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.dashboard-stat-left {\n  display: flex;\n  align-items: center;\n}\n\n.dashboard-stat-number {\n  font-weight: bold;\n  margin-right: 0.5rem;\n  font-size: var(--font-size-xxl);\n  color: var(--text-primary);\n}\n\n.dashboard-pending-badge {\n  background-color: rgba(241, 173, 180, 0.7);\n  color: #e96565;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.dashboard-stat-right {\n  text-align: right;\n}\n\n.dashboard-stat-label {\n  color: #6c757d;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n}\n\n/* Add Button */\n.dashboard-add-button {\n  background-color: var(--primary-background);\n  color: white;\n  padding: 0.25rem 0.5rem;\n  margin-left: 0.5rem;\n  border-radius: 0.375rem;\n  border-radius: 0.25rem;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  margin-top: 0.25rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.dashboard-add-button:hover {\n  background-color: var(--primary-background) !important;\n  color: var(--custom-background-color-white);\n}\n\n.dashboard-add-icon {\n  margin-right: 0.25rem;\n}\n\n/* Responsive Design */\n@media (min-width: 1200px) {\n  .dashboard-card-col {\n    width: 33.333333%;\n    max-width: 33.333333%;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1199.98px) {\n  .dashboard-card-col {\n    width: 50%;\n    max-width: 50%;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .dashboard-card-col {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-card-body {\n    padding: 1.5rem !important;\n  }\n\n  .dashboard-icon-wrapper {\n    width: 40px !important;\n    height: 40px !important;\n    font-size: var(-font-size-xl) !important;\n  }\n\n  .dashboard-stat-number {\n    font-size: var(-font-size-xl) !important;\n  }\n\n  .dashboard-welcome-text {\n    font-size: var(-font-size-xl)\n  }\n\n  .dashboard-container {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .dashboard-container {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n  }\n\n  .dashboard-stat-row {\n    flex-direction: column;\n    align-items: flex-start !important;\n  }\n\n  .dashboard-stat-right {\n    text-align: left !important;\n    width: 100%;\n    margin-top: 0.5rem;\n  }\n\n  .dashboard-card-title {\n    font-size: var(-font-size-sm);\n  }\n\n  .dashboard-stat-number {\n    font-size: 18px !important;\n  }\n\n  .dashboard-welcome-text {\n    font-size: 1.1rem;\n  }\n\n  .dashboard-user-badge {\n    font-size: var(-font-size-md);\n    padding: 0.4rem 0.6rem;\n  }\n}\n\n.muted-hr {\n  border: none;\n  border-top: 2px solid #c5c6c7;\n  margin: 1rem 0;\n}\n\n.vertical-hr {\n  border: none;\n  border-left: 2px solid #c5c6c7;\n  height: 50px;\n}\n\n/* Dashboard New styles end */\nbody[data-sidebar-size=sm] .vertical-menu #sidebar-menu ul li:hover ul li span {\n  display: block;\n}\n#sidebar-menu ul li div.menu-parent-link {\n  padding: .6rem 1rem;\n  color: #585f64;\n  position: relative;\n  font-weight: 400;\n  transition: all .4s;\n  margin: 0 10px;\n  /* border-radius: 3px; */\n  \n  font-size: 16px;\n  font-family: Roboto, sans-serif;\n  -webkit-box-align: center;\n}\n\n#sidebar-menu ul li div.menu-parent-link .nav-icon {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  min-width: 1.5rem;\n  vertical-align: middle;\n  color: #585f64;\n  -webkit-transition: all .3s;\n  transition: all .3s;\n  top: -1px;\n}\n\n#sidebar-menu ul li div.menu-parent-link:hover,\n#sidebar-menu ul li div.menu-parent-link:hover .nav-icon {\n  color: #145886;\n}\n\nbody[data-sidebar-size=sm] .vertical-menu #sidebar-menu>ul>li span,\nbody[data-sidebar-size=sm] .vertical-menu #sidebar-menu>ul>li li span,\nbody[data-sidebar-size=sm] .vertical-menu #sidebar-menu>ul>li .ms-auto {\n  display: none;\n  padding-left: 25px;\n}\n\nbody[data-sidebar=dark][data-sidebar-size=sm] .vertical-menu #sidebar-menu ul li div.menu-parent-link:hover span {\n  display: block;\n}\n\n\nbody[data-sidebar-size=sm] .vertical-menu #sidebar-menu>ul>li:hover>div.menu-parent-link+ul {\n  left: 25px;\n  width: 241px;\n}\n\nbody[data-sidebar-size=sm] .vertical-menu #sidebar-menu>ul>li:hover>div.menu-parent-link span {\n  display: block;\n}\n\n\nbody[data-sidebar=dark][data-sidebar-size=sm] .vertical-menu #sidebar-menu>ul>li:hover>div.menu-parent-link {\n  background: #E6F2FF;\n  color: var(--bs-btn-active-bg);\n  position: relative;\n  width: calc(210px + 70px);\n  transition: none;\n  /* box-shadow: inset 0 3px 10px 0 rgba(154, 161, 171, .2); */\n}\n\n\n.bulk-import-offcanvas {\n  width: 400px;\n}\n\n@media (max-width: 768px) {\n  .bulk-import-offcanvas {\n    width: 100%;\n  }\n}\n\n.custom-offcanvas-width {\n  width: 400px;\n}\n\n@media (max-width: 768px) {\n  .custom-offcanvas-width {\n    width: 100%;\n  }\n}\n\n.role-selection-offcanvas {\n  height: 246px !important;\n}\n\n@media (max-width: 768px) {\n  .role-selection-offcanvas {\n    height: 250px;\n  }\n}\n\n.responsive-search-input {\n  width: 100%;\n}\n\n/* Small screens (xs) - Hide search completely or make very small */\n@media (max-width: 860px) {\n  .search-box.pf-search-box {\n    display: none !important;\n    /* Completely hide on mobile if needed */\n  }\n\n  /* OR if you want to keep it but make it smaller: */\n  /*\n    .responsive-search-input {\n      width: 120px !important;\n      font-size: 12px;\n    }\n    .search-box.pf-search-box form {\n      padding: 0.25rem !important;\n    }\n    */\n}\n\n/* Medium screens (sm to md) - Reduce search width, hide time */\n@media (min-width: 576px) and (max-width: 991.98px) {\n  .responsive-search-input {\n    max-width: 250px;\n  }\n}\n\n/* Large screens and up - Full width search, show time */\n@media (min-width: 992px) {\n  .responsive-search-input {\n    max-width: none;\n  }\n}\n\n\n/* new css */\n\n\n.dashboard-user-badge {\n  background-color: #F37920;\n  color: var(--custom-background-color-white);\n  /* padding: 0.5rem 1.75rem 6px 29px; */\n  padding: 7px 35px 7px 35px;\n}\n\n.btn-primary,\n.page-item.active .page-link,\n.v-avatar {\n  background-color: #F37920 !important;\n  border-color: #F37920;\n}\n\n\nbutton.btn.btn-primary.mt-3.btn.btn-primary {\n  padding: 6px 25px 6px 25px;\n}\n\nbutton.btn-siz.btn.btn-primary {\n  padding: 8px 30px 8px 30px;\n}\n\nbutton.btn.btn-primary {\n  font-size: 14px;\n}\n\na.pf-btn.btn-primary.pf-nav-btn {\n  padding: 8px 29px 10px 29px;\n  margin-left: 0.5rem;\n  border-radius: 0.375rem;\n}\n\nbutton.py-0.px-1.\\!text-\\[12px\\].btn.btn-primary.btn-sm {\n  padding: 8px 25px 8px 25px !important;\n}\n\nbutton.py-0.px-1.\\!text-\\[12px\\].btn.btn-outline-primary.btn-sm {\n  padding: 8px 25px 8px 25px !important;\n}\n\n.bg-\\[\\#0d4473\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 97 254);\n}\n\n\nbutton.me-2.btn.btn-success {\n  padding: 5px 26px 5px 26px;\n}\n\n#page-topbar .search-box input {\n  height: 38px;\n  font-size: 15px;\n}\n\n\n.dashboard-stat-number {\n  font-size: 20px;\n}\n\n@media (min-width: 768px) {\n  h6.m-2 {\n    font-weight: 500;\n  }\n}\n\n\n@media (min-width: 1024px) {\n  h6.m-2 {\n    font-weight: 600;\n  }\n}\n\n.d-flex.flex-column.offcanvas-body {\n  overflow: hidden;\n}\n\n.border-t-\\[\\#0d4473\\] {\n  --tw-border-opacity: 1;\n  border-top-color: rgb(0 97 254);\n}\n\ntable.core-ui-table thead tr,\ntable.core-ui-table tbody tr:hover,\ntable.core-ui-table tbody tr:hover td {\n    background-color: #f9fafb;\n}\n\ntable.core-ui-table thead tr th {\n  background-color: inherit;\n}\ntable.core-ui-table tr{\n  border: 1px solid #ddd;\n  border-bottom-width: 1px;\n}\n\ntable.core-ui-table tr td,\ntable.core-ui-table tr th {\n  border: none;\n}\n\n.hd-card {\n  padding: 0px !important;\n  padding-bottom: 12px !important;\n}\n\n/* .btn-outline-secondary:hover {\n    color: var(--bs-btn-hover-color);\n    background-color: #F37920!important;\n    border-color: #F37920!important;\n} */\n.bg-green-500 {\n  --tw-bg-opacity: 1;\n  /* background-color: rgb(241 230 109); */\n  background-color: rgb(0 97 254);\n}\n\n/* .form-select {\n    padding: 13.375px 2.25rem .375rem .75rem!important;\n} */\n\n.fw-semibold {\n  color: #01041b;\n}\n\n.bg-gradient.p-3.card-header {\n  padding: 12px 15px 12px 15px !important;\n}\n\n\n.no-vertical-border tr {\n  border-left: none !important;\n  border-right: none !important;\n}\n.no-vertical-border td {\n  border-left: none !important;\n  border-right: none !important;\n}\n.no-vertical-border th {\n  border-left: none !important;\n  border-right: none !important;\n}\n\n/* Custom styles for your tabs */\n.custom-tabs .nav-link {\n  color: rgb(0 97 254); /* Default gray color */\n  transition: color 0.2s ease;\n}\n\n.custom-tabs .nav-link:hover {\n  color: #000000 !important; /* Black on hover */\n}\n\n.custom-tabs .nav-link.active {\n  color: #F37920 !important; /* Blue for active tab */\n  border-bottom-color: #F37920 !important;\n}\n\n.custom-tabs .nav-link.active:hover {\n  color: #000000 !important; /* Blue for active tab */\n  border-bottom-color: #000000 !important;\n}\n\n.border.border-blue {\n  border-color:  rgb(0 97 254) !important;\n}\n\n.react-datepicker__month-wrapper {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  padding: 1rem;\n}\n\n.react-datepicker__month-text {\n  padding: 0.5rem 0;\n  text-align: center;\n  font-weight: 500;\n  border-radius: 0.375rem;\n  cursor: pointer;\n}\n\n.react-datepicker__month-text:hover {\n  background-color: #e2e8f0;\n}\n\n.react-datepicker__month-text--selected {\n  background-color: #2563eb; \n  color: white;\n}\n.custom-yellow-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  background-color: #FEF3C7; \n  color: #92400E;            \n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 9999px;     \n}\n\n.tooltip.show {\n    opacity: 1!important;\n}\n@layer utilities {\n  /* Hide close icon inside RangePicker */\n  .hide-clear-icon .ant-picker-clear {\n    display: none !important;\n  }\n}\n:where(.css-dev-only-do-not-override-mc1tut).ant-picker:hover .ant-picker-suffix:not(:last-child) {\n    opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
